import { ModelNumber } from '../SmartBoard';
export class SmartBoard {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1.00';
        this.modelNumber = ModelNumber.SB6000;
        this.power = false;
        this.videoSelection = 'hdmi1';
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /get (fwverscr|fwversion)/i,
                callback: (match) => {
                    this.socket.send(`${match[1].toLowerCase()}=${this.firmwareVersion}`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /get powerstate/i,
                callback: (match) => {
                    const offResponse = this.modelNumber === ModelNumber.SB6000 ? 'standby' : 'ready';
                    this.socket.send(`powerstate=${this.power ? 'on' : offResponse}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /set powerstate=(on|standby|powersave|ready)/i,
                callback: (match) => {
                    this.power = match[1].toLowerCase() === 'on';
                    this.socket.send(`powerstate=${match[1]}`);
                },
            },
            {
                name: 'videoQuery',
                regExp: /get input/i,
                callback: (match) => {
                    this.socket.send(`input=${this.videoSelection}`);
                },
            },
            {
                name: 'videoSet',
                regExp: /set input=(.+)/i,
                callback: (match) => {
                    this.videoSelection = match[1];
                    this.socket.send(`input=${this.videoSelection}`);
                },
            },
            {
                name: 'volumeQuery',
                regExp: /get volume/i,
                callback: (match) => {
                    this.socket.send(`volume=${this.volume.toString().padStart(3, '0')}`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /set volume=(\d+)/i,
                callback: (match) => {
                    this.volume = parseInt(match[1], 10);
                    this.socket.send(`volume=${this.volume.toString().padStart(3, '0')}`);
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /get mute/i,
                callback: (match) => {
                    this.socket.send(`mute=${this.volumeMute ? 'on' : 'off'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /set mute=(.+)/i,
                callback: (match) => {
                    this.volumeMute = match[1].toLowerCase() === 'on';
                    this.socket.send(`mute=${this.volumeMute ? 'on' : 'off'}`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`invalidcmd`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a, _b;
        this.modelNumber = (_a = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _a !== void 0 ? _a : ModelNumber.SB6000;
        let lowestCode;
        for (const videoInput of Object.values((_b = config.videoInputs) !== null && _b !== void 0 ? _b : {})) {
            if (this.videoSelection === lowestCode)
                return;
            if (lowestCode === undefined ||
                parseInt(videoInput.code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = videoInput.code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : 'hdmi1';
    }
}
SmartBoard.emulatorType = 'socketEmulator';
SmartBoard.key = '-LvGbvQDnePZestGJSyS';
